import { apiCall } from '../helpers/axios';

const ENDPOINT = 'appointments';

const create = async (params) => {
    try {
        const response = await apiCall().post(`${ENDPOINT}/create`, params);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const deleteOne = async (id) => {
    try {
        const response = await apiCall().delete(`${ENDPOINT}/${id}/delete`);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

export default {
    create,
    deleteOne,
}


// WEBPACK FOOTER //
// ./src/services/appointment-service.js